<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-6">
      <v-btn icon @click="$emit('back')">
        <v-icon size="26">mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn v-if="showEdit" icon @click="$emit('edit')">
        <v-icon size="26">mdi-pencil</v-icon>
      </v-btn>
    </div>
    <div class="d-flex justify-space-between mb-10">
      <p class="card-title mb-0">№ {{ id }}</p>
      <div>
        <slot name="date" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminCardHeader',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
